module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-2f46d7aa5acbae996dc95f9645bcbcb5.webp";